const download = async (condition, cb, options = {}, endCb) => {
  const perPage = condition.per_page || 100;
  let params = {
    ...condition,
    total: 0,
    page: 0,
    per_page: perPage
  };
  const tHeader = options.tHeader;
  const name = options.name;
  const init = (list, total) => {
    if (list && list.length > 0) {
      params.total += list.length;
      downloadRequest(list, tHeader, name);
    }
    if ((params.total < total) || total === 'init') {
      params.page += 1;
      cb(params, init);
    } else {
      endCb?.();
    }
  }
  init([], 'init');
}

const downloadRequest = async (dataList, tHeader, name) => {
  import('./Export2Excel').then(excel => {
    excel.export_json_to_excel({
      header: tHeader,
      data: dataList,
      filename: name
    })
  })
}

export default download;